import './scripts/globals';
import './scripts/main';